import { render, staticRenderFns } from "./ChooseRest.vue?vue&type=template&id=80df9db8&"
import script from "./ChooseRest.vue?vue&type=script&lang=js&"
export * from "./ChooseRest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports